const getVideoThumbnailUrls = (remoteUris: string[]) => {
  return remoteUris.map(url => url.split('?thumbnail_url=')[1])
}

export default getVideoThumbnailUrls
